//TODO: Evaluate if all these statuses are still neede or can be computed.
const statusColorsMap = {
  'Not Started': 'je-neutral-indicator',
  'Collecting Images': 'je-secondary-indicator',
  'In Review': 'je-primary-indicator',
  'Complete': 'je-success-indicator',
  'Scheduled': 'je-tertiary-indicator',
}

export { statusColorsMap }
